module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/新技术发展-text.ed6fb3d3.png";